// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__GAF9Q","split":"styles_split__QzyCV","nonSplit":"styles_nonSplit__eTpn9"};